import AppConfig from '@/modules/core/client/app/config';

import '@/modules/core/client/core.client.module';

AppConfig.registerModule('success', ['core']);

// config
require('@/modules/payment/client/config/success.client.routes');

// directives
require('@/modules/payment/client/directives/onboarding-complete-react.directive');
require('@/modules/payment/client/directives/reauth-react.directive');
